module.exports = __webpack_public_path__ + "img/man-mualla.c962cf8b.png";